import { localStorageStore } from 'react-admin';

const store = localStorageStore();

export default store;
